import { CoachingTrendData } from '../../card--my-coaching-card/models/coaching-trend-data.model';
import { PayloadAction } from '../../store.model';
import { generatePerformanceTrendData } from '../functions/generate-performace-metric-trend-data.function';
import { PerformanceMetricData } from '../models/performance-metric-data.model';
import { ActionType } from '../my-performance-card.action';
import { PerformanceCardState } from '../my-performance-card.state';

import { GetPerformanceDataResultAction } from './performance-data.action';

export const handleGetPerformanceDataResult = (
    state: PerformanceCardState,
    action: PayloadAction<
        ActionType.MY_PERFORMANCE_CARD__GET_PERFORMANCE_DATA_RESULT,
        GetPerformanceDataResultAction
    >,
): PerformanceCardState => {
    const { performanceData, userId, metricId, queueId } = action.payload;

    const metricsDictionary = performanceData.reduce<
        Record<number, PerformanceMetricData[]>
    >((dict, metric) => {
        if (metric.metricID == null) return dict;

        if (dict[metric.metricID] == null) {
            dict[metric.metricID] = [];
        }

        dict[metric.metricID].push(metric);
        return dict;
    }, {});

    const trendCharts: Record<string, CoachingTrendData> = Object.entries(
        metricsDictionary,
    ).reduce<Record<string, CoachingTrendData>>(
        (acc, [metricID, metricData]) => {
            const key = `${userId}-${metricID ?? ''}-${queueId ?? ''}`;
            acc[key] = generatePerformanceTrendData(metricData);
            return acc;
        },
        {},
    );

    const key = `${userId}-${metricId ?? ''}-${queueId ?? ''}`;

    return {
        ...state,
        pending: {
            ...state.pending,
            trendDataByKey: {
                ...(state.pending?.trendDataByKey ?? {}),
                [key]: false,
            },
        },
        trendCharts: {
            ...(state.trendCharts ?? {}),
            ...trendCharts,
        },
    };
};
